var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import React from 'react';
import { observer } from "mobx-react";
import { Button, Menu, MenuButton, MenuItemOption, MenuList } from '@chakra-ui/react';
import { action, makeObservable, observable } from 'mobx';
import { FiChevronDown } from '@react-icons/all-files/fi/FiChevronDown';
export class MultiChoiceMenuState {
    constructor() {
        this.buttonLabel = "Select";
        this.options = [];
        this.showmenu = false;
        this.color = '';
        this.selectedOptions = new Set();
        this.randomprefix = Math.random();
        makeObservable(this);
    }
    setSelection(key, sel) {
        var _a;
        const lkey = key + this.randomprefix;
        if (sel) {
            this.selectedOptions.add(lkey);
        }
        else {
            this.selectedOptions.delete(lkey);
        }
        (_a = this.onOptionSelectionChanged) === null || _a === void 0 ? void 0 : _a.call(this, sel, key);
    }
    setLabel(label) {
        this.buttonLabel = label;
    }
    addOption(opt) {
        this.options.push(opt);
    }
    setShow(show) {
        this.showmenu = show;
    }
    clearOption() {
        this.options = [];
    }
    toggle() {
        if (this.showmenu) {
            this.setShow(false);
        }
        else {
            this.setShow(true);
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], MultiChoiceMenuState.prototype, "buttonLabel", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], MultiChoiceMenuState.prototype, "options", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MultiChoiceMenuState.prototype, "showmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MultiChoiceMenuState.prototype, "color", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], MultiChoiceMenuState.prototype, "selectedOptions", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Boolean]),
    __metadata("design:returntype", void 0)
], MultiChoiceMenuState.prototype, "setSelection", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MultiChoiceMenuState.prototype, "setLabel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MultiChoiceMenuState.prototype, "addOption", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MultiChoiceMenuState.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MultiChoiceMenuState.prototype, "clearOption", null);
let MultiChoiceMenu = class MultiChoiceMenu extends React.Component {
    constructor(prop) {
        super(prop);
    }
    render() {
        return (React.createElement(Menu, { key: this.props.state.randomprefix, isOpen: this.props.state.showmenu, closeOnSelect: false },
            React.createElement(MenuButton, { onClick: () => this.props.state.toggle(), as: Button, rightIcon: React.createElement(FiChevronDown, null) }, this.props.state.buttonLabel),
            this.props.state.showmenu && React.createElement(MenuList, { key: "List" + this.props.state.randomprefix, minWidth: "240px" }, this.props.state.options.map((opt) => React.createElement(MenuItemOption, { type: 'checkbox', onClick: (e) => this.props.state.setSelection(opt.key, !this.props.state.selectedOptions.has(opt.key + this.props.state.randomprefix)), isChecked: this.props.state.selectedOptions.has(opt.key + this.props.state.randomprefix) ? true : false, key: opt.key + "_" + this.props.state.randomprefix, value: opt.key + "_" + this.props.state.randomprefix, color: opt.color ? opt.color : 'black' }, opt.value)))));
    }
};
MultiChoiceMenu = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], MultiChoiceMenu);
export { MultiChoiceMenu };
